<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="服务器名或IP"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getServers">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addServer">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="servers" highlight-current-row v-loading="listLoading"  style="width: 100%;" @sort-change="sortchange" :height="bodyHeight-220">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="serverName" label="服务器名称" min-width="150" sortable="custom">
      </el-table-column>
      <el-table-column prop="serverIP" label="IP地址" min-width="200" sortable="custom">
      </el-table-column>
      <el-table-column prop="controlUrl" label="控制地址" min-width="200" sortable="custom">
      </el-table-column>
      <el-table-column prop="status" label="状态" min-width="80" :formatter="formatStatus" sortable="custom">
      </el-table-column>
      <el-table-column prop="createDate" label="创建日期" min-width="140" sortable="custom" :formatter="formatdate">
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template scope="scope">
          <el-button size="small" @click="editServer(scope.$index, scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="delServer(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="serverTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" size="tiny">
      <el-form :model="addForm" label-width="100px" :rules="addFormRules" ref="addForm">
        <el-form-item label="服务器名称" prop="serverName">
          <el-input v-model="addForm.serverName"></el-input>
        </el-form-item>
        <el-form-item label="IP地址" prop="serverIP">
          <el-input v-model="addForm.serverIP"></el-input>
        </el-form-item>
         <el-form-item label="密钥" prop="secret">
          <el-input v-model="addForm.secret"></el-input>
        </el-form-item>
        <el-form-item label="控制地址" prop="controlUrl">
          <el-input v-model="addForm.controlUrl">
            <el-select v-model="addForm.controlUrlPrefix" slot="prepend" size="large" placeholder="请选择">
              <el-option label="http://" value="http://"></el-option>
              <el-option label="https://" value="https://"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <el-form-item label="状态" prop="status">
           <el-select v-model="addForm.status" placeholder="请选择">
              <el-option label="正常" value = 0></el-option>
              <el-option label="停用" value = 1></el-option>
            </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveServer" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<style>
  .el-input-group .el-select .el-input {
    width:90px;
  }
</style>

<script>
export default {
  name: 'servermanage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: ''
      },
      listLoading: false,
      sortname: 'serverName',
      sorttype: 'ascending',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      tableheight: window.innerHeight - 220,
      servers: [
      ],
      serverTitle: '新增',
      isEditModel: false,
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        serverName: [
          { required: !this.isEditModel, message: '请输入服务器名称', trigger: 'blur' }
        ],
        serverIP: [
          { required: true, message: '请输入服务器IP', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              var reg = /^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
              if (reg.test(value)) {
                callback()
              } else {
                callback(new Error('不合法的IP地址'))
              }
            }
          }
        ],
        controlUrl: [
          { required: true, message: '请输入控制地址', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
        serverId: 0,
        serverName: '',
        serverIP: '',
        secret: '',
        controlUrl: '',
        status: '0',
        controlUrlPrefix: ''
      }
    }
  },
  methods: {
    formatdate: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 性别显示转换
    formatStatus: function(row) {
      if (row.status === 0) {
        return '正常'
      } else if (row.status === 1) {
        return '停用'
      } else if (row.status === -1) {
        return '删除'
      } else {
        return '未知'
      }
    },
    // 获取用户列表
    getServers: function() {
      let para = {
        keywords: this.filters.keywords,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/Server/GetServers',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.servers = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getServers()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getServers()
    },
    addServer: function() {
      this.serverTitle = '服务器新增'
      this.isEditModel = false
      this.addFormVisible = true
      this.addForm = {
        serverId: 0,
        serverName: '',
        serverIP: '',
        secret: '',
        controlUrl: '',
        status: '0',
        controlUrlPrefix: ''
      }
      this.$refs.addForm.resetFields()
    },
    saveServer: function() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({}, this.addForm)
          para.controlUrl = para.controlUrlPrefix + para.controlUrl + '/'
          this.$ajax({
            url: 'api/Server/SaveServer',
            data: JSON.stringify(para),
            loadingName: 'addLoading',
            success: (response) => {
              this.$message({
                message: '保存成功',
                type: 'success',
                duration: 1000
              })
              this.$refs['addForm'].resetFields()
              this.addFormVisible = false
              this.getServers()
            }
          })
        }
      })
    },
    editServer: function(index, row) {
      var reg = /^(https|http|ftp|rtsp|mms)?:\/\//
      this.serverTitle = '服务器编辑'
      this.isEditModel = true
      this.$ajax({url: 'api/Server/GetServerInfo?serverId=' + row.serverId,
        success: (response) => {
          this.addForm = response
          var p = this.addForm.controlUrl.match(reg)
          this.addForm.controlUrlPrefix = (p != null ? p[0] : 'http://')
          this.addForm.controlUrl = this.addForm.controlUrl.replace(reg, '').replace(/(\/*$)/g, '')
          this.addForm.status = this.addForm.status.toString()
          this.addFormVisible = true
          this.$refs.addForm.resetFields()
        }
      })
    },
    delServer: function(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        this.listLoading = true
        let para = [row.serverId]
        this.$ajax({
          url: 'api/Server/DeleteServers',
          data: JSON.stringify(para)
        }).then((res) => {
          this.listLoading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getServers()
        })
      }).catch(() => {
      })
    }
  },
  mounted() {
    this.getServers()
  }
}
</script>